import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import TextArea from '@atlaskit/textarea';
import { FormValues } from '../../../types/ChampionApplicationFormTypes';

type FieldErrors = {
  whyBecomeChampion?: string;
};

type Props = {
  values: FormValues;
  updateField: <K extends keyof FormValues>(key: K, value: FormValues[K]) => void;
  errors?: FieldErrors;
};

export const MotivationSection: React.FC<Props> = ({ values, updateField, errors }) => {
  return (
    <fieldset css={sectionBoxStyles}>
      <legend css={legendLabelStyles}>
        <span css={requiredStyles}>*</span>{' '}
        Why would you like to become an Atlassian Champion?
      </legend>

      <div css={controlTopStyles}>
        <TextArea
          id="why-become-champion"
          placeholder="Tell us in a few sentences - between 150 and 300 characters"
          value={values.whyBecomeChampion}
          onChange={(e) => updateField('whyBecomeChampion', e.target.value)}
        />

        {errors?.whyBecomeChampion && <div css={errorStyles}>{errors.whyBecomeChampion}</div>}
      </div>
    </fieldset>
  );
};

const sectionBoxStyles = css({
  border: `1px solid ${token('color.border')}`,
  borderRadius: '4px',
  padding: token('space.300'),
  marginBottom: token('space.400'),
  backgroundColor: token('elevation.surface'),
});

const legendLabelStyles = css({
  fontWeight: 600,
  fontSize: '14px',
});

const controlTopStyles = css({
  marginTop: token('space.100'),
});

const requiredStyles = css({
  color: token('color.text.danger'),
});

const errorStyles = css({
  color: token('color.text.danger'),
  fontSize: '12px',
  marginTop: token('space.050'),
});
